import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuestionService } from 'src/app/services/api/question.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from '../../../config';
import { WidgetsQuestionModel } from '../../../models/widgets/widgets-question.model';
import { MetadataAreaAbstract } from 'src/app/abstract/widgets/metadata-area.abstract';

@Component({
  selector: 'app-metadata-question-api',
  templateUrl: './metadata-question-api.component.html',
  styleUrls: ['./metadata-question-api.component.scss']
})
export class MetadataQuestionApiComponent extends MetadataAreaAbstract implements OnInit {
  @Input() data: WidgetsQuestionModel;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  widgetsQuestionData: WidgetsQuestionModel = new WidgetsQuestionModel();

  form: FormGroup = this.fb.group({
    label: ['', [Validators.required, Validators.maxLength(500)]],
    namespace: ['', [Validators.required, Validators.maxLength(50)]],
    description: ['', [Validators.required]],
    typeId: ['', [Validators.required, Validators.pattern("^[1-9]+[0-9]*$")]],
    tag: ['']
  });
  tags: any[] = [];

  constructor(
    private questionService: QuestionService,
    private fb: FormBuilder) {
    super();
    this.data = new WidgetsQuestionModel();
  }

  /* eslint-disable @typescript-eslint/dot-notation */
  ngOnInit(): void {
    this.widgetsQuestionData = this.data;
    if (this.data.dbId) {
      this.form.controls['label'].setValue(this.data.name);
      this.form.controls["description"].setValue(this.data.description);
      this.form.controls["typeId"].setValue(this.data.typeId);
      this.form.controls["namespace"].setValue(this.data.key);
      this.tags = this.data.tags;
    }
  }

  /* eslint-enable */
  addTags(tag: any): void {
    this.tags.push(tag.target.value);
  }

  removeTags(tag: any): void {
    this.tags.forEach((element, index) => {
      if (element === tag) {
        this.tags.splice(index, 1);
      }
    });
  }

  onSubmit() {
    /* eslint-disable @typescript-eslint/dot-notation */
    const id = this.data ? this.data['dbId'] : 0;
    this.widgetsQuestionData.name = this.form.controls['label'].value;
    this.widgetsQuestionData.description = this.form.controls['description'].value;
    this.widgetsQuestionData.key = this.form.controls['namespace'].value;
    this.widgetsQuestionData.tags = this.tags;

    /* eslint-disable @typescript-eslint/naming-convention */
    const formData = {
      Id: id,
      Label: this.form.controls['label'].value,
      TypeId: this.form.controls['typeId'].value,
      Namespace: this.form.controls['namespace'].value,
      Description: this.form.controls['description'].value,
      CreatedBy: Config.user.iNumber,
      Template: this.widgetsQuestionData,
      Tags: this.tags
    };

    /* eslint-enable */
    if (this.tags.length > 0) {
      this.questionService.saveQuestion(formData).subscribe(res => {
        if (res) {
          this.notifyParent.emit("Saving Data");
        }
      });
    }
  }
}
